import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import PrivacyPolicy from './legal/PrivacyPolicy';
import TermsOfService from './legal/TermsOfService';

const LegalModal = ({ isOpen, activePage, onClose }: any) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const getTitle = () => {
    if (activePage === 'privacy') return 'Privacy Policy';
    if (activePage === 'terms') return 'Terms of Service';
    return '';
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "linear" }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-12 bg-swiss-black/80 backdrop-blur-sm"
        >
          {/* Modal Container */}
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 20, opacity: 0 }}
            transition={{ duration: 0.3, ease: "linear" }}
            className="w-full max-w-4xl max-h-[90vh] bg-swiss-white border-4 border-swiss-black shadow-[16px_16px_0px_0px_#5DCEA6] flex flex-col overflow-hidden"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-6 md:p-8 border-b-4 border-swiss-black bg-swiss-muted shrink-0">
              <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tighter text-swiss-black">
                {getTitle()}
              </h2>
              <button
                onClick={onClose}
                className="w-12 h-12 flex items-center justify-center border-4 border-swiss-black bg-swiss-white hover:bg-swiss-red hover:text-swiss-white transition-colors duration-150 ease-linear text-xl focus:outline-none shrink-0"
                aria-label="Close"
              >
                <X />
              </button>
            </div>

            {/* Content Area (Scrollable) */}
            <div className="p-6 md:p-12 overflow-y-auto bg-swiss-white">
              <p className="text-sm font-bold uppercase tracking-widest text-swiss-black mb-8 opacity-60">
                Last Updated: August 20, 2026
              </p>
              
              {activePage === 'privacy' && <PrivacyPolicy />}
              {activePage === 'terms' && <TermsOfService />}
              
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LegalModal;
